<div
    class="ui-message"
    [ngClass]="type"
    [style.display]="state().value === 'inactive' ? 'none' : ''">
    <div>
        @switch (type) {
            @case('success') {
                <app-svg-icon icon="check-circle" size="small" fill="transparent" stroke="green-900"></app-svg-icon>
            }
            @case('warning') {
                <app-svg-icon icon="exclamation-circle" size="small" fill="transparent" stroke="orange-900"></app-svg-icon>
            }
            @case('error') {
                <app-svg-icon icon="exclamation-circle" size="small" fill="transparent" stroke="red-900"></app-svg-icon>
            }
            @case('info') {
                <app-svg-icon icon="exclamation-circle" size="small" fill="transparent" stroke="voyage-blue"></app-svg-icon>
            }
        }
    </div>
    <div class="ui-message__box">
        @if (title) {
            <h4 class="ui-message__title">{{title}}</h4>
        }
        @if (message) {
            @if (options.enableHtml) {
                <div
                    class="ui-message__desc"
                    [class]="options.messageClass"
                    [innerHTML]="message | safeHtml: SanitizerValueType.HTML">
                </div>
            } @else {
                <div
                    class="ui-message__desc"
                    [class]="options.messageClass">
                    {{ message }}
                </div>
            }
        }
    </div>
    @if (options.closeButton) {
        <div class="ui-message__close">
            <app-svg-icon icon="close-icon" size="xsmall" fill="grays-text-light-gray"></app-svg-icon>
        </div>
    }
</div>